import React, { FunctionComponent } from 'react';

import { ErrorCannotOrder } from 'app/components/error-cannot-order';
import { i18n } from 'app/i18n';
import { monkeyImageProps } from 'app/resources/images';
import { DataLayerErrorType } from 'app/data-layers/model/data-layer-error-type';

export const CannotOrderProductNotAvailablePage: FunctionComponent = () => (
    <ErrorCannotOrder
        title={i18n.page.error.cannotOrderProductNotAvailable.title}
        subtitles={[
            i18n.page.error.cannotOrderProductNotAvailable.firstSubtitle,
            i18n.page.error.cannotOrderProductNotAvailable.secondSubtitle,
        ]}
        image={monkeyImageProps}
        hideCustomerServiceText={true}
        dataLayerErrorType={DataLayerErrorType.PRODUCT_NOT_AVAILABLE_ERROR}
    />
);
